import SiteView from "@/react/components/entityViews/site/SiteView";

export const SitePage = () => {
  return (
    <div className="relative flex flex-1 flex-col bg-background w-full min-w-0 min-h-0" id="site-page">
      <div className="flex-1 min-h-0">
        <SiteView />
      </div>
    </div>
  );
};

export default SitePage;
